<router-outlet *ngIf="isSupported"></router-outlet>
<app-unsupported-browser *ngIf="!isSupported"></app-unsupported-browser>
